/* helper.ts */

/* React */
import type { CSSProperties } from "react";

/**
 * Each column should have the exact same padding.
 * If there are more than two columns,
 * we need to set the padding for the first and last column
 * explicitly, using the index and length of rows.
 */
export const getRowStyles = (
  rowIndex: number,
  rowCount: number
): CSSProperties => {
  if (rowCount <= 2) return { padding: "12px 0px 0px 0px" };
  if (rowIndex === 0)
    return { padding: "12px 0px 0px 0px" };
  if (rowIndex === rowCount - 1)
    return { padding: "0px 0px 0px 0px" };
  return { padding: "12px 0px 12px 0px" };
};
